import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import local JSON files
import en from "../src/locales/CulturalHeritage/en.json";
import hi from "../src/locales/CulturalHeritage/hi.json";
import mr from "../src/locales/CulturalHeritage/mr.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    mr: { translation: mr },
  },
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already escapes
  },
});

export default i18n;
